var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _closeButton, _contentInner, _storageKey, _isDesignMode, _shouldPersistCloseDecision, _sectionId, _presenceStyle, _heightObserver, _mobileMedia, _layoutActive, _lastHeights, _viewportFlowRAF, _viewportFlowUnsub, _viewportFlowTravel, _firstSectionNaturalTop, _viewportPageMargin, _firstStickyViewportEls, _viewportTransitionTimer, _viewportEditorReadyRAF, _viewportScrollTransitionDuration, _viewportScrollTransitionEasing, _checkClosedState, _handleClose, _TopbarComponent_instances, setupEditorListeners_fn, teardownEditorListeners_fn, _restoreTopbar, _handleEditorViewportRefresh, _handleStickyConsumerStateChange, _handleAnnouncementPaddingIntent, getAnnouncementPaddingState_fn, syncContentPaddingMode_fn, activateLayout_fn, deactivateLayout_fn, _handleResize, _handleBreakpointChange, publishHeight_fn, setViewportEditorPending_fn, scheduleViewportEditorReady_fn, _scheduleStandaloneViewportFlow, _shouldPollNativeViewport, publishStandaloneViewportProgress_fn, stopStandaloneViewportFlow_fn, notifyLayoutChange_fn;
import { getThemeSettings } from "./utilities-ClmlCyst.js";
import { onScrollFrameUpdate } from "./scroll-dispatcher-BIs-vu0Q.js";
import "./waapi-patch-BCt4pEht.js";
import "./cookie-banner-layout-DZP7Q0uT.js";
import "./section-anchor-scroll-Bvm-mXVl.js";
import "./mobile-anim-gate-Btn1wVuD.js";
const STICKY_VIEWPORT_CONSUMER_SELECTOR = [
  "[data-sticky-viewport-height]",
  "[data-sticky-viewport-top]"
].join(", ");
const STICKY_VIEWPORT_READY_ATTRIBUTE = "data-sticky-viewport-ready";
const ANNOUNCEMENT_PADDING_INTENT_EVENT = "announcement:topbar-padding-intent-change";
const ANNOUNCEMENT_COMPACT_REQUEST_ATTRIBUTE = "data-topbar-compact-request";
const ANNOUNCEMENT_PADDING_MEASURED_ATTRIBUTE = "data-topbar-padding-measured";
const COMPACT_PADDING_ATTRIBUTE = "data-compact-content-padding";
const PADDING_PENDING_ATTRIBUTE = "data-content-padding-pending";
const ROW_JUSTIFY_CONTENT_ATTRIBUTE = "data-row-justify-content";
const ROW_JUSTIFY_CONTENT_MOBILE_ATTRIBUTE = "data-row-justify-content-mb";
const isStickyConsumerEnabled = (el, isMobile) => !isMobile || !el.hasAttribute("data-sticky-desktop-only");
const isDynamicStickyConsumer = (el) => !el.hasAttribute("data-sticky-static-fill") && !el.hasAttribute("data-sticky-disabled");
const parseCssLengthToPx = (value, rootFontSize = 16) => {
  const normalized = value.trim().toLowerCase();
  const parsed = parseFloat(normalized);
  if (!Number.isFinite(parsed)) return 0;
  if (normalized.endsWith("rem")) return parsed * rootFontSize;
  return parsed;
};
const _TopbarComponent = class _TopbarComponent extends HTMLElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _TopbarComponent_instances);
    __privateAdd(this, _closeButton, null);
    __privateAdd(this, _contentInner, null);
    __privateAdd(this, _storageKey, "");
    __privateAdd(this, _isDesignMode, false);
    __privateAdd(this, _shouldPersistCloseDecision, true);
    __privateAdd(this, _sectionId, "");
    __privateAdd(this, _presenceStyle, null);
    __privateAdd(this, _heightObserver, null);
    __privateAdd(this, _mobileMedia, null);
    __privateAdd(this, _layoutActive, false);
    __privateAdd(this, _lastHeights, /* @__PURE__ */ new Map());
    __privateAdd(this, _viewportFlowRAF, null);
    __privateAdd(this, _viewportFlowUnsub, null);
    __privateAdd(this, _viewportFlowTravel, 0);
    __privateAdd(this, _firstSectionNaturalTop, 0);
    __privateAdd(this, _viewportPageMargin, 0);
    __privateAdd(this, _firstStickyViewportEls, []);
    __privateAdd(this, _viewportTransitionTimer, null);
    __privateAdd(this, _viewportEditorReadyRAF, null);
    __privateAdd(this, _viewportScrollTransitionDuration, "0s");
    __privateAdd(this, _viewportScrollTransitionEasing, null);
    __privateAdd(this, _checkClosedState, () => {
      try {
        if (sessionStorage.getItem(__privateGet(this, _storageKey)) === "true") {
          __privateMethod(this, _TopbarComponent_instances, deactivateLayout_fn).call(this, { disablePresence: true });
          this.remove();
          return true;
        }
      } catch (error) {
      }
      return false;
    });
    __privateAdd(this, _handleClose, (event) => {
      var _a;
      (_a = event == null ? void 0 : event.preventDefault) == null ? void 0 : _a.call(event);
      if (__privateGet(this, _isDesignMode)) {
        __privateMethod(this, _TopbarComponent_instances, deactivateLayout_fn).call(this, { disablePresence: true });
        this.style.display = "none";
        __privateMethod(this, _TopbarComponent_instances, notifyLayoutChange_fn).call(this);
      } else {
        if (__privateGet(this, _shouldPersistCloseDecision)) {
          try {
            sessionStorage.setItem(__privateGet(this, _storageKey), "true");
          } catch (error) {
          }
        }
        __privateMethod(this, _TopbarComponent_instances, deactivateLayout_fn).call(this, { disablePresence: true });
        this.remove();
        __privateMethod(this, _TopbarComponent_instances, notifyLayoutChange_fn).call(this);
      }
    });
    __privateAdd(this, _restoreTopbar, (event) => {
      var _a;
      __privateMethod(this, _TopbarComponent_instances, setViewportEditorPending_fn).call(this);
      __privateGet(this, _scheduleStandaloneViewportFlow).call(this);
      if (((_a = event == null ? void 0 : event.detail) == null ? void 0 : _a.sectionId) !== __privateGet(this, _sectionId) && event) return;
      try {
        sessionStorage.removeItem(__privateGet(this, _storageKey));
      } catch (error) {
      }
      this.style.display = "";
      __privateMethod(this, _TopbarComponent_instances, activateLayout_fn).call(this);
      __privateMethod(this, _TopbarComponent_instances, syncContentPaddingMode_fn).call(this);
      __privateGet(this, _scheduleStandaloneViewportFlow).call(this);
    });
    __privateAdd(this, _handleEditorViewportRefresh, () => {
      __privateMethod(this, _TopbarComponent_instances, setViewportEditorPending_fn).call(this);
      __privateGet(this, _scheduleStandaloneViewportFlow).call(this);
    });
    __privateAdd(this, _handleStickyConsumerStateChange, () => {
      __privateMethod(this, _TopbarComponent_instances, setViewportEditorPending_fn).call(this);
      __privateGet(this, _scheduleStandaloneViewportFlow).call(this);
    });
    __privateAdd(this, _handleAnnouncementPaddingIntent, () => {
      __privateMethod(this, _TopbarComponent_instances, syncContentPaddingMode_fn).call(this);
    });
    __privateAdd(this, _handleResize, (entries) => {
      if (!__privateGet(this, _layoutActive) || _TopbarComponent.layoutOwner !== this) return;
      const entry = entries[0];
      const borderBox = Array.isArray(entry == null ? void 0 : entry.borderBoxSize) ? entry.borderBoxSize[0] : entry == null ? void 0 : entry.borderBoxSize;
      __privateMethod(this, _TopbarComponent_instances, publishHeight_fn).call(this, (borderBox == null ? void 0 : borderBox.blockSize) ?? this.getBoundingClientRect().height);
    });
    __privateAdd(this, _handleBreakpointChange, () => {
      if (!__privateGet(this, _layoutActive) || _TopbarComponent.layoutOwner !== this) return;
      __privateMethod(this, _TopbarComponent_instances, setViewportEditorPending_fn).call(this);
      __privateMethod(this, _TopbarComponent_instances, syncContentPaddingMode_fn).call(this);
      __privateMethod(this, _TopbarComponent_instances, publishHeight_fn).call(this, this.getBoundingClientRect().height);
    });
    __privateAdd(this, _scheduleStandaloneViewportFlow, () => {
      if (__privateGet(this, _viewportFlowRAF)) cancelAnimationFrame(__privateGet(this, _viewportFlowRAF));
      __privateSet(this, _viewportFlowRAF, requestAnimationFrame(() => {
        var _a;
        __privateSet(this, _viewportFlowRAF, null);
        __privateMethod(this, _TopbarComponent_instances, stopStandaloneViewportFlow_fn).call(this);
        if (!this.isConnected || document.querySelector("header-v3-component"))
          return;
        const firstSection = document.querySelector(
          "#MainContent > .shopify-section:first-child"
        );
        const main = document.getElementById("MainContent");
        if (!firstSection || !main) {
          __privateMethod(this, _TopbarComponent_instances, scheduleViewportEditorReady_fn).call(this);
          return;
        }
        __privateSet(this, _firstStickyViewportEls, [
          ...firstSection.querySelectorAll(STICKY_VIEWPORT_CONSUMER_SELECTOR)
        ].filter(
          (el) => {
            var _a2;
            return !el.closest(".popup-inner") && isStickyConsumerEnabled(el, (_a2 = __privateGet(this, _mobileMedia)) == null ? void 0 : _a2.matches);
          }
        ));
        if (!__privateGet(this, _firstStickyViewportEls).length) {
          __privateMethod(this, _TopbarComponent_instances, scheduleViewportEditorReady_fn).call(this);
          return;
        }
        __privateSet(this, _viewportFlowTravel, Math.max(
          0,
          main.getBoundingClientRect().top + window.scrollY
        ));
        __privateSet(this, _firstSectionNaturalTop, Math.max(
          0,
          firstSection.getBoundingClientRect().top + window.scrollY
        ));
        const rootStyle = getComputedStyle(document.documentElement);
        const rootFontSize = parseFloat(rootStyle.fontSize) || 16;
        const pageMarginToken = ((_a = __privateGet(this, _mobileMedia)) == null ? void 0 : _a.matches) ? "--page-margin-mb" : "--page-margin";
        __privateSet(this, _viewportPageMargin, Math.max(
          0,
          parseCssLengthToPx(
            rootStyle.getPropertyValue(pageMarginToken),
            rootFontSize
          )
        ));
        __privateMethod(this, _TopbarComponent_instances, publishStandaloneViewportProgress_fn).call(this, window.scrollY, false);
        __privateMethod(this, _TopbarComponent_instances, scheduleViewportEditorReady_fn).call(this);
        __privateSet(this, _viewportFlowUnsub, onScrollFrameUpdate(
          (data) => {
            __privateMethod(this, _TopbarComponent_instances, publishStandaloneViewportProgress_fn).call(this, data.scrollY, true);
          },
          { shouldPollNative: __privateGet(this, _shouldPollNativeViewport) }
        ));
      }));
    });
    __privateAdd(this, _shouldPollNativeViewport, (scrollY) => {
      var _a;
      return this.isConnected && !document.hidden && !((_a = __privateGet(this, _mobileMedia)) == null ? void 0 : _a.matches) && __privateGet(this, _firstStickyViewportEls).some(
        (el) => el.isConnected && isDynamicStickyConsumer(el)
      ) && scrollY + __privateGet(this, _viewportPageMargin) < __privateGet(this, _firstSectionNaturalTop);
    });
  }
  connectedCallback() {
    __privateSet(this, _storageKey, this.getAttribute("data-storage-key") || `theme:topbar:closed:${this.id}`);
    __privateSet(this, _sectionId, this.getAttribute("data-section-id") || this.id);
    __privateSet(this, _isDesignMode, Boolean(window.Shopify && window.Shopify.designMode));
    const useSmoothScroll = getThemeSettings().useSmoothScroll;
    __privateSet(this, _viewportScrollTransitionDuration, useSmoothScroll ? "0s" : "0.1s");
    __privateSet(this, _viewportScrollTransitionEasing, useSmoothScroll ? null : "linear");
    __privateSet(this, _presenceStyle, this.querySelector("[data-topbar-presence-style]"));
    if (__privateGet(this, _isDesignMode) || !__privateGet(this, _shouldPersistCloseDecision)) {
      try {
        sessionStorage.removeItem(__privateGet(this, _storageKey));
      } catch (error) {
      }
    }
    if (__privateGet(this, _isDesignMode)) {
      __privateMethod(this, _TopbarComponent_instances, setupEditorListeners_fn).call(this);
    } else if (__privateGet(this, _shouldPersistCloseDecision)) {
      if (__privateGet(this, _checkClosedState).call(this)) return;
      window.addEventListener("pageshow", __privateGet(this, _checkClosedState));
    }
    __privateSet(this, _closeButton, this.querySelector(".topbar-close-btn"));
    __privateSet(this, _contentInner, this.querySelector(".topbar-custom-content-inner"));
    this.addEventListener(
      ANNOUNCEMENT_PADDING_INTENT_EVENT,
      __privateGet(this, _handleAnnouncementPaddingIntent)
    );
    __privateMethod(this, _TopbarComponent_instances, activateLayout_fn).call(this);
    __privateMethod(this, _TopbarComponent_instances, syncContentPaddingMode_fn).call(this);
    __privateMethod(this, _TopbarComponent_instances, setViewportEditorPending_fn).call(this);
    window.addEventListener(
      "sticky-viewport:consumer-state-change",
      __privateGet(this, _handleStickyConsumerStateChange)
    );
    __privateGet(this, _scheduleStandaloneViewportFlow).call(this);
    if (__privateGet(this, _closeButton)) {
      __privateGet(this, _closeButton).addEventListener("click", __privateGet(this, _handleClose));
    }
  }
  disconnectedCallback() {
    if (__privateGet(this, _closeButton)) {
      __privateGet(this, _closeButton).removeEventListener("click", __privateGet(this, _handleClose));
    }
    this.removeEventListener(
      ANNOUNCEMENT_PADDING_INTENT_EVENT,
      __privateGet(this, _handleAnnouncementPaddingIntent)
    );
    if (!__privateGet(this, _isDesignMode) && __privateGet(this, _shouldPersistCloseDecision)) {
      window.removeEventListener("pageshow", __privateGet(this, _checkClosedState));
    }
    __privateMethod(this, _TopbarComponent_instances, teardownEditorListeners_fn).call(this);
    window.removeEventListener(
      "sticky-viewport:consumer-state-change",
      __privateGet(this, _handleStickyConsumerStateChange)
    );
    if (__privateGet(this, _viewportEditorReadyRAF)) {
      cancelAnimationFrame(__privateGet(this, _viewportEditorReadyRAF));
      __privateSet(this, _viewportEditorReadyRAF, null);
    }
    if (__privateGet(this, _isDesignMode) && !document.querySelector("header-v3-component")) {
      document.querySelectorAll(STICKY_VIEWPORT_CONSUMER_SELECTOR).forEach((el) => el.setAttribute(STICKY_VIEWPORT_READY_ATTRIBUTE, ""));
    }
    __privateMethod(this, _TopbarComponent_instances, deactivateLayout_fn).call(this);
    __privateMethod(this, _TopbarComponent_instances, stopStandaloneViewportFlow_fn).call(this);
    __privateSet(this, _closeButton, null);
    __privateSet(this, _contentInner, null);
  }
};
_closeButton = new WeakMap();
_contentInner = new WeakMap();
_storageKey = new WeakMap();
_isDesignMode = new WeakMap();
_shouldPersistCloseDecision = new WeakMap();
_sectionId = new WeakMap();
_presenceStyle = new WeakMap();
_heightObserver = new WeakMap();
_mobileMedia = new WeakMap();
_layoutActive = new WeakMap();
_lastHeights = new WeakMap();
_viewportFlowRAF = new WeakMap();
_viewportFlowUnsub = new WeakMap();
_viewportFlowTravel = new WeakMap();
_firstSectionNaturalTop = new WeakMap();
_viewportPageMargin = new WeakMap();
_firstStickyViewportEls = new WeakMap();
_viewportTransitionTimer = new WeakMap();
_viewportEditorReadyRAF = new WeakMap();
_viewportScrollTransitionDuration = new WeakMap();
_viewportScrollTransitionEasing = new WeakMap();
_checkClosedState = new WeakMap();
_handleClose = new WeakMap();
_TopbarComponent_instances = new WeakSet();
setupEditorListeners_fn = function() {
  document.addEventListener("shopify:section:select", __privateGet(this, _restoreTopbar));
  document.addEventListener("shopify:section:load", __privateGet(this, _restoreTopbar));
  document.addEventListener("shopify:block:select", __privateGet(this, _restoreTopbar));
  document.addEventListener(
    "shopify:section:reorder",
    __privateGet(this, _handleEditorViewportRefresh)
  );
};
teardownEditorListeners_fn = function() {
  document.removeEventListener("shopify:section:select", __privateGet(this, _restoreTopbar));
  document.removeEventListener("shopify:section:load", __privateGet(this, _restoreTopbar));
  document.removeEventListener("shopify:block:select", __privateGet(this, _restoreTopbar));
  document.removeEventListener(
    "shopify:section:reorder",
    __privateGet(this, _handleEditorViewportRefresh)
  );
};
_restoreTopbar = new WeakMap();
_handleEditorViewportRefresh = new WeakMap();
_handleStickyConsumerStateChange = new WeakMap();
_handleAnnouncementPaddingIntent = new WeakMap();
getAnnouncementPaddingState_fn = function(child) {
  const announcement = child.querySelector("announcement-component");
  if ((announcement == null ? void 0 : announcement.dataset.display) !== "carousel") {
    return { preserveCenter: false, pending: false };
  }
  return {
    preserveCenter: !announcement.hasAttribute(
      ANNOUNCEMENT_COMPACT_REQUEST_ATTRIBUTE
    ),
    pending: !announcement.hasAttribute(
      ANNOUNCEMENT_PADDING_MEASURED_ATTRIBUTE
    )
  };
};
syncContentPaddingMode_fn = function() {
  var _a;
  if (!__privateGet(this, _closeButton) || !__privateGet(this, _contentInner)) {
    this.removeAttribute(COMPACT_PADDING_ATTRIBUTE);
    this.removeAttribute(PADDING_PENDING_ATTRIBUTE);
    return;
  }
  const isMobile = Boolean((_a = __privateGet(this, _mobileMedia)) == null ? void 0 : _a.matches);
  const widthAttribute = isMobile ? "data-width-mb" : "data-width";
  const rowJustifyAttribute = isMobile ? ROW_JUSTIFY_CONTENT_MOBILE_ATTRIBUTE : ROW_JUSTIFY_CONTENT_ATTRIBUTE;
  const rowIsCentered = this.getAttribute(rowJustifyAttribute) === "center";
  const visibleChildren = Array.from(__privateGet(this, _contentInner).children).filter(
    (child) => child.hasAttribute(widthAttribute) && getComputedStyle(child).display !== "none"
  );
  let preserveCenter = false;
  let paddingPending = false;
  if (visibleChildren.length === 1 && rowIsCentered) {
    const child = visibleChildren[0];
    if (child.classList.contains("announcement-bar")) {
      const announcementState = __privateMethod(this, _TopbarComponent_instances, getAnnouncementPaddingState_fn).call(this, child);
      preserveCenter = announcementState.preserveCenter;
      paddingPending = announcementState.pending;
    } else {
      preserveCenter = child.getAttribute(widthAttribute) === "fit";
    }
  }
  this.toggleAttribute(COMPACT_PADDING_ATTRIBUTE, !preserveCenter);
  if (!paddingPending) this.removeAttribute(PADDING_PENDING_ATTRIBUTE);
};
activateLayout_fn = function() {
  var _a, _b;
  if (__privateGet(this, _layoutActive)) return;
  const previousOwner = _TopbarComponent.layoutOwner;
  if (previousOwner && previousOwner !== this)
    __privateMethod(_a = previousOwner, _TopbarComponent_instances, deactivateLayout_fn).call(_a);
  _TopbarComponent.layoutOwner = this;
  __privateSet(this, _layoutActive, true);
  (_b = __privateGet(this, _presenceStyle)) == null ? void 0 : _b.removeAttribute("media");
  __privateSet(this, _mobileMedia, window.matchMedia("(max-width: 991.98px)"));
  __privateGet(this, _mobileMedia).addEventListener("change", __privateGet(this, _handleBreakpointChange));
  if ("ResizeObserver" in window) {
    __privateSet(this, _heightObserver, new ResizeObserver(__privateGet(this, _handleResize)));
    __privateGet(this, _heightObserver).observe(this);
  } else {
    __privateMethod(this, _TopbarComponent_instances, publishHeight_fn).call(this, this.getBoundingClientRect().height);
  }
};
deactivateLayout_fn = function({ disablePresence = false } = {}) {
  var _a, _b, _c;
  if (disablePresence) (_a = __privateGet(this, _presenceStyle)) == null ? void 0 : _a.setAttribute("media", "not all");
  __privateMethod(this, _TopbarComponent_instances, stopStandaloneViewportFlow_fn).call(this);
  (_b = __privateGet(this, _heightObserver)) == null ? void 0 : _b.disconnect();
  __privateSet(this, _heightObserver, null);
  (_c = __privateGet(this, _mobileMedia)) == null ? void 0 : _c.removeEventListener(
    "change",
    __privateGet(this, _handleBreakpointChange)
  );
  __privateSet(this, _mobileMedia, null);
  __privateSet(this, _layoutActive, false);
  if (_TopbarComponent.layoutOwner !== this) return;
  _TopbarComponent.layoutOwner = null;
  __privateGet(this, _lastHeights).clear();
  document.documentElement.style.removeProperty("--first-full-topbar-height");
  document.documentElement.style.removeProperty(
    "--first-full-topbar-height-mb"
  );
};
_handleResize = new WeakMap();
_handleBreakpointChange = new WeakMap();
publishHeight_fn = function(height) {
  var _a;
  const roundedHeight = Math.ceil(height * 100) / 100;
  const property = ((_a = __privateGet(this, _mobileMedia)) == null ? void 0 : _a.matches) ? "--first-full-topbar-height-mb" : "--first-full-topbar-height";
  if (!roundedHeight) return;
  if (roundedHeight === __privateGet(this, _lastHeights).get(property)) {
    __privateGet(this, _scheduleStandaloneViewportFlow).call(this);
    return;
  }
  __privateGet(this, _lastHeights).set(property, roundedHeight);
  document.documentElement.style.setProperty(property, `${roundedHeight}px`);
  __privateMethod(this, _TopbarComponent_instances, notifyLayoutChange_fn).call(this);
  __privateGet(this, _scheduleStandaloneViewportFlow).call(this);
};
setViewportEditorPending_fn = function(elements = document.querySelectorAll(STICKY_VIEWPORT_CONSUMER_SELECTOR)) {
  if (!__privateGet(this, _isDesignMode) || document.querySelector("header-v3-component")) {
    return;
  }
  if (__privateGet(this, _viewportEditorReadyRAF)) {
    cancelAnimationFrame(__privateGet(this, _viewportEditorReadyRAF));
    __privateSet(this, _viewportEditorReadyRAF, null);
  }
  elements.forEach((el) => {
    if (!(el == null ? void 0 : el.isConnected) || el.closest(".popup-inner")) return;
    el.removeAttribute(STICKY_VIEWPORT_READY_ATTRIBUTE);
  });
};
scheduleViewportEditorReady_fn = function(elements = document.querySelectorAll(STICKY_VIEWPORT_CONSUMER_SELECTOR)) {
  if (!__privateGet(this, _isDesignMode) || document.querySelector("header-v3-component")) {
    return;
  }
  if (__privateGet(this, _viewportEditorReadyRAF)) {
    cancelAnimationFrame(__privateGet(this, _viewportEditorReadyRAF));
  }
  const candidates = [...elements];
  __privateSet(this, _viewportEditorReadyRAF, requestAnimationFrame(() => {
    __privateSet(this, _viewportEditorReadyRAF, null);
    if (!this.isConnected || document.querySelector("header-v3-component"))
      return;
    candidates.forEach((el) => {
      var _a;
      if (!(el == null ? void 0 : el.isConnected) || el.closest(".popup-inner") || !isStickyConsumerEnabled(el, (_a = __privateGet(this, _mobileMedia)) == null ? void 0 : _a.matches)) {
        return;
      }
      el.setAttribute(STICKY_VIEWPORT_READY_ATTRIBUTE, "");
    });
  }));
};
_scheduleStandaloneViewportFlow = new WeakMap();
_shouldPollNativeViewport = new WeakMap();
publishStandaloneViewportProgress_fn = function(scrollY, fromScroll) {
  const activeEls = __privateGet(this, _firstStickyViewportEls).filter(
    (el) => el.isConnected && isDynamicStickyConsumer(el)
  );
  if (!activeEls.length) return;
  const progress = __privateGet(this, _viewportFlowTravel) > 0 ? Math.min(1, Math.max(0, scrollY / __privateGet(this, _viewportFlowTravel))) : 1;
  const progressValue = String(Math.round(progress * 1e4) / 1e4);
  const flowTopValue = `${Math.round(Math.max(0, __privateGet(this, _firstSectionNaturalTop) - scrollY) * 1e3) / 1e3}px`;
  const transitionValue = fromScroll ? __privateGet(this, _viewportScrollTransitionDuration) : "var(--trans-duration)";
  const transitionEasing = fromScroll ? __privateGet(this, _viewportScrollTransitionEasing) : null;
  let progressChanged = false;
  activeEls.forEach((el) => {
    const elementProgressChanged = el.style.getPropertyValue("--sticky-viewport-topbar-exit-progress") !== progressValue;
    const flowTopChanged = el.style.getPropertyValue("--sticky-viewport-runtime-flow-top") !== flowTopValue;
    const viewportProgressChanged = elementProgressChanged || flowTopChanged;
    if (viewportProgressChanged) progressChanged = true;
    if ((!fromScroll || viewportProgressChanged) && el.style.getPropertyValue("--sticky-viewport-transition-duration") !== transitionValue) {
      el.style.setProperty(
        "--sticky-viewport-transition-duration",
        transitionValue
      );
    }
    if (!fromScroll || viewportProgressChanged) {
      const currentTransitionEasing = el.style.getPropertyValue(
        "--sticky-viewport-transition-easing"
      );
      if (transitionEasing) {
        if (currentTransitionEasing !== transitionEasing) {
          el.style.setProperty(
            "--sticky-viewport-transition-easing",
            transitionEasing
          );
        }
      } else if (currentTransitionEasing) {
        el.style.removeProperty("--sticky-viewport-transition-easing");
      }
    }
    if (elementProgressChanged) {
      el.style.setProperty(
        "--sticky-viewport-topbar-exit-progress",
        progressValue
      );
    }
    if (flowTopChanged) {
      el.style.setProperty(
        "--sticky-viewport-runtime-flow-top",
        flowTopValue
      );
    }
  });
  if (fromScroll && progressChanged) {
    clearTimeout(__privateGet(this, _viewportTransitionTimer));
    __privateSet(this, _viewportTransitionTimer, setTimeout(() => {
      __privateSet(this, _viewportTransitionTimer, null);
      activeEls.forEach((el) => {
        if (!el.isConnected) return;
        if (el.style.getPropertyValue(
          "--sticky-viewport-transition-duration"
        ) !== "var(--trans-duration)") {
          el.style.setProperty(
            "--sticky-viewport-transition-duration",
            "var(--trans-duration)"
          );
        }
        if (el.style.getPropertyValue("--sticky-viewport-transition-easing")) {
          el.style.removeProperty("--sticky-viewport-transition-easing");
        }
      });
    }, 80));
  } else if (!fromScroll) {
    clearTimeout(__privateGet(this, _viewportTransitionTimer));
    __privateSet(this, _viewportTransitionTimer, null);
  }
};
stopStandaloneViewportFlow_fn = function() {
  var _a;
  if (__privateGet(this, _viewportFlowRAF)) cancelAnimationFrame(__privateGet(this, _viewportFlowRAF));
  __privateSet(this, _viewportFlowRAF, null);
  (_a = __privateGet(this, _viewportFlowUnsub)) == null ? void 0 : _a.call(this);
  __privateSet(this, _viewportFlowUnsub, null);
  clearTimeout(__privateGet(this, _viewportTransitionTimer));
  __privateSet(this, _viewportTransitionTimer, null);
  __privateGet(this, _firstStickyViewportEls).forEach((el) => {
    if (!el.isConnected) return;
    el.style.removeProperty("--sticky-viewport-topbar-exit-progress");
    el.style.removeProperty("--sticky-viewport-runtime-flow-top");
    el.style.removeProperty("--sticky-viewport-transition-duration");
    el.style.removeProperty("--sticky-viewport-transition-easing");
  });
  __privateSet(this, _firstStickyViewportEls, []);
  __privateSet(this, _viewportFlowTravel, 0);
  __privateSet(this, _firstSectionNaturalTop, 0);
  __privateSet(this, _viewportPageMargin, 0);
};
notifyLayoutChange_fn = function() {
  window.dispatchEvent(new CustomEvent("topbar:layout-change"));
};
__publicField(_TopbarComponent, "layoutOwner", null);
let TopbarComponent = _TopbarComponent;
if (!customElements.get("topbar-component")) {
  customElements.define("topbar-component", TopbarComponent);
}
